import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function voidResult(source$: Observable<any>): Observable<void> {
	return source$.pipe(map(() => void 0));
}
